/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global Network, API_PATH, schema, restCollection, snackbar */

/**
 * Provides a Library for calling some Rest funcitons.
 * Each function returns a Promise. On Error, the Promise throws the http status code.
 * @param {string} schemaKey
 * Key of schema from global object <i>schema</i>
 * @returns {Rest}
 */
function Rest(schemaKey) {
  if (!this instanceof Rest) return new Rest(schemaKey);

  const that = this;

  // -- attributes --
  this.schemaKey = schemaKey;
  this.schema = schema[schemaKey];
  this.schemaData = this.schema.schemaData;
  this.endPoint = this.schema.endPoint;
  this.searchAttributes = [];

  this.onreload = function () {
    console.warn("onreload() Overwrite this!");
  };

  // -- public functions --
  this.statistic = statistic;
  this.dashboardData = dashboardData;
  this.find = find;
  this.findOne = findOne;
  this.textSearch = textSearch;
  this.count = count;
  this.createEmptyInstance = createEmptyInstance;
  this.parseValidationError = parseValidationError;
  this.request = request;
  this.fileUpload = fileUpload;

  // -- init some stuff --
  //self executing anonyms function to throw away the scope after initialazation and save memory.
  (function () {
    //search attributes
    for (let key in that.schemaData) {
      const schemaItem = that.schemaData[key];

      switch (schemaItem.type) {
        case "text":
          that.searchAttributes.push(key);
          break;
        case "model":
        case "collection":
          if (schemaItem.hideInTable) break;

          //try to get the text attributes from the source schema
          const collectionSchemaKey = schemaItem.via || key;
          let collectionSchema = schema[collectionSchemaKey];
          if (!collectionSchema) break;

          const collectionSchemaData = collectionSchema.schemaData;
          for (let colKey in collectionSchemaData) {
            const colSchemaItem = collectionSchemaData[colKey];

            if (that.schemaData.template && key === "partner") {
            } else if (colSchemaItem.type === "text") {
              that.searchAttributes.push(key + "." + colKey);
            }
          }
          break;
      }
    }
  })();

  function statistic(options) {
    let path = that.endPoint;
    path += "/getStatistic?from=";
    path += options.startDate + "&to=";
    path += options.endDate + "&fromTime=";
    path += options.startTime + "&toTime=";
    path += options.endTime;

    return request("GET", path)
      .then((xhr) => {
        if (xhr.status !== 200) throw xhr;
        return JSON.parse(xhr.responseText);
      })
      .catch((xhr) => {
        throw xhr.status;
      });
  }

  function dashboardData(options) {
    let path = that.endPoint;
    path += "/getDashboardData";

    return request("GET", path)
      .then((xhr) => {
        if (xhr.status !== 200) throw xhr;
        return JSON.parse(xhr.responseText);
      })
      .catch((xhr) => {
        throw xhr.status;
      });
  }

  /**
   * Perform an usual REST GET request
   * @param {object} options
   * Avaiable options. All optional. All strings.<br>
   * prefix, limit, skip, where, populate, suffix
   * @returns {Promise}
   */
  function find(options) {
    options = options || {};
    options.limit = options.limit || null;
    options.skip = options.skip || null;
    options.where = options.where || null;
    options.sort = options.sort || null;
    options.populate =
      options.populate || options.populate === "" ? options.populate : null;
    options.prefix = options.prefix || "";
    options.suffix = options.suffix || "";

    if (typeof options.where === "object")
      options.where = JSON.stringify(options.where);

    let path = that.endPoint;
    path += options.prefix;
    path += "?";
    path += options.limit ? "&limit=" + options.limit : "";
    path += options.skip ? "&skip=" + options.skip : "";
    path += options.where ? "&where=" + options.where : "";
    path += options.sort ? "&sort=" + options.sort : "";
    path += options.nostreetschema ? "&nostreetschema=true" : "";
    path +=
      options.populate || options.populate === ""
        ? "&populate=" + options.populate
        : "";
    path += options.nostreetschema ? "&nostreetschema=true" : "";
    path += options.suffix;

    return request("GET", path)
      .then((xhr) => {
        if (xhr.status !== 200) throw xhr;
        try {
          return JSON.parse(xhr.responseText);
        } catch (e) {
          console.log("GET ERROR", e);
        }
      })
      .catch((xhr) => {
        throw xhr.status;
      });
  }

  /**
   * Performs a textsearch with automatic search attribte detextion.
   * @param {object} options
   * Same options like on <i>find()</i>.
   * Additional <i>search</i>.
   * @returns {Promise}
   * From <i>find()</i>
   */
  function textSearch(options) {
    options.prefix = options.prefix || "";
    options.search = options.search || "";
    options.suffix = options.suffix || "";
    // + same options like on find()

    if (that.endPoint.includes("automaticExport")) {
      that.searchAttributes = ["name"];
    }

    if (that.endPoint.includes("form")) {
      that.searchAttributes = ["name", "isAffiliate"];
    }

    options.prefix += "/textSearch";
    options.suffix += `&search=${
      options.search
    }&attributes=${that.searchAttributes.join(",")}`;

    return find(options);
  }

  /**
   * Take a fresh copy of requested object from server.
   * Also upgrades the object.
   * @param {string} id
   * Id of object.
   * @returns {Promise}
   * Will be resolved with <i>null</i> on parse Error or with <i>xhr.status</i>.
   */
  function findOne(id) {
    return request("GET", that.endPoint + "/" + id + "?populate")
      .then((xhr) => {
        if (xhr.status !== 200) throw xhr;

        let data = JSON.parse(xhr.responseText);

        if (!data) return null;

        return new RestSubject(that, data);
      })
      .catch((e) => {
        if (e.status !== undefined) throw e.status;
        throw e;
      });
  }

  function count(onlyActive = false) {
    let param = "";
    if (onlyActive) param = "?active=true";

    return request("GET", that.endPoint + "/count" + param)
      .then((xhr) => {
        if (xhr.status !== 200) throw xhr;

        const data = JSON.parse(xhr.responseText);
        return data.n;
      })
      .catch((xhr) => 0);
  }

  /**
   * Simple JSON request.
   * @param {string} method
   * HTTP method. GET, POST, PUT, DELETE, ...
   * @param {string} url
   * Url request send to
   * @param {object} data
   * Data wich should send be as JSON
   * @returns {Promise}
   * Will be resolved with xhr. Or rejected on Error with xhr.
   * Cause responseText is readOnly, no parse done here.
   */
  function request(method, url, data) {
    return new Promise((resolve, reject) => {
      const xhr = Network.openXHR(method, url);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;

        resolve(xhr);
      };
      xhr.onerror = () => reject(xhr);
      xhr.send(JSON.stringify(data));
    });
  }

  /**
   *
   * @param {string} method
   * @param {string} url
   * @param {File} file
   * @param {object} data
   * Optional additional parameter
   * @returns {Promise}
   */
  function fileUpload(method, url, file, data) {
    data = data || {};

    return new Promise((resolve, reject) => {
      const formData = new FormData();

      for (let i in data) formData.append(i, data[i]);
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open(method, url);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;

        resolve(xhr);
      };
      xhr.onerror = () => reject(xhr);
      xhr.send(formData);
    });
  }

  /**
   * Creates an empty instance by schema and default options
   * @param {object} blueprint
   * Some models requies a blueprint.
   * Use an instance of it returned by a <i>Rest.find()</i> function.
   * @returns {object}
   */
  function createEmptyInstance(blueprint) {
    let obj = {
      id: null,
    };

    for (let key in that.schema.schemaData) {
      let schemaItem = that.schema.schemaData[key];

      switch (schemaItem.type) {
        case "password":
        case "datetime":
        case "date":
        case "number":
        case "text":
        case "email":
          obj[key] =
            schemaItem.defaultsTo !== undefined ? schemaItem.defaultsTo : "";
          break;
        case "checkbox":
          obj[key] =
            schemaItem.defaultsTo !== undefined ? schemaItem.defaultsTo : false;
          break;
        case "select":
          obj[key] =
            schemaItem.defaultsTo !== undefined
              ? schemaItem.defaultsTo
              : schemaItem.options[0];
          break;
        case "collection":
          obj[key] = [];
          break;
        case "file":
        case "model":
        case "static":
        case "button":
          obj[key] = null;
          break;
        case "json":
          obj[key] =
            schemaItem.defaultsTo !== undefined ? schemaItem.defaultsTo : "[]";
          break;
        case "area":
          obj[key] =
            schemaItem.defaultsTo !== undefined ? schemaItem.defaultsTo : "";
          break;
        default:
          console.error(`SchemaItem.type ${schemaItem.type} not implemented`);
      }
    }

    obj = new RestSubject(that, obj);
    
    if (!blueprint) return obj;

    //apply data from blueprint object
    for (var key in that.schema) {
      let blueprintVal = blueprint[key];

      if (!blueprintVal) continue;

      obj[key] = blueprintVal;
    }

    return obj;
  }

  function parseValidationError(e) {
    /*
     * Example Error message
     * "[Error (E_VALIDATION) 2 attributes are invalid] Invalid attributes sent to User:\n • login\n   • `undefined` should be a string (instead of \"null\", which is a object)\n   • \"required\" validation rule failed for input: null\nSpecifically, it threw an error.  Details:\n undefined\n • password\n   • `undefined` should be a string (instead of \"null\", which is a object)\n   • \"minLength\" validation rule failed for input: null\nSpecifically, it threw an error.  Details:\n undefined\n   • \"required\" validation rule failed for input: null\nSpecifically, it threw an error.  Details:\n undefined\n"
     */

    let msg = e.message;
    if (!msg || msg.indexOf("E_VALIDATION") === -1) return null;

    const result = {};
    msg = msg.split("\n");

    let lastKey = null;

    let i = 0;
    const len = msg.length;
    for (; i < len; i++) {
      let line = msg[i];
      switch (line.substr(0, 3)) {
        case " • ": //main point
          //get key of wrong attribute
          lastKey = line.substr(3);
          result[lastKey] = [];
          break;
        case "   ": //sub point (dot is on index 3)
          //add error message to attribute
          result[lastKey].push(parseLine(line.substr(5)));
          break;
        default:
          continue;
      }
    }

    return result;

    /**
     * Parse the error message to a shorter string
     * @param {string} line
     * @returns {string}
     */
    function parseLine(line) {
      if (line.indexOf("required") !== -1) return "required";

      if (line.indexOf("minLength") !== -1) return "minLength";

      if (line.indexOf("maxLength") !== -1) return "maxLength";

      if (line.indexOf("already exists") !== -1) return "unique";

      if (line.indexOf("mail") !== -1) return "mail";

      return line;
    }
  }
}
